export enum FocusElement {
  MOBILE_NAV_BAR = 'MOBILE_NAV_BAR',
  ORDER_SUMMARY = 'ORDER_SUMMARY',
}
